import { useEffect, useState } from "react";
import BaseHookWithUpdaters from "./baseHookWithUpdaters";
import { api_postValueOrErrorMessage } from "../Api/util";

class Filters extends BaseHookWithUpdaters {

    filters:any = {
      genders: ["woman", "couple"],
      thermometers: ["soft"]
    }

    constructor(){
      super();
      let item = localStorage.getItem("filters");
      if(item){
        this.filters = JSON.parse(item);
      }
    }

    updateFilter = (key:string, value:any) => {
      if(value === "yes" || value === "no"){
         this.filters[key] = value;
         localStorage.setItem("filters", JSON.stringify(this.filters));
          return this.update();
      }
      if(this.filters[key]) {
        if(!this.filters[key].includes(value)) this.filters[key].push(value);
        else this.filters[key] = this.filters[key].filter((e:any) => value !== e);
      }
      else this.filters[key] = [value];
      this.filters[key].sort();
      this.update();
      this.persist();
    }

    /**
     * Replace a filter's whole value in one go. The sheets edit a draft and commit it
     * on Apply, so they cannot use updateFilter, which toggles one value at a time and
     * would fire a request per tap.
     */
    setFilter = (key:string, value:any) => {
      if(Array.isArray(value)) this.filters[key] = [...value].sort();
      else if(value === undefined || value === null) delete this.filters[key];
      else this.filters[key] = value;
      this.update();
      this.persist();
    }

    /** Commit several filters at once, for the More filters sheet's single Apply. */
    setFilters = (values:{[key:string]:any}) => {
      for(const key in values){
        const value = values[key];
        if(Array.isArray(value)) this.filters[key] = [...value].sort();
        else if(value === undefined || value === null) delete this.filters[key];
        else this.filters[key] = value;
      }
      this.update();
      this.persist();
    }

    /** "Don't filter by this" - an empty list, not a missing key. */
    clearFilter = (key:string) => this.setFilter(key, Array.isArray(this.filters[key]) ? [] : undefined);

    private persist = () => {
      localStorage.setItem("filters", JSON.stringify(this.filters));
      // The API only knows about these two; everything else stays on the client.
      api_postValueOrErrorMessage("user/informations/modify", {
        filter_genders: this.filters.genders,
        filter_thermometers: this.filters.thermometers
      });
    }
}

export const FILTERS = new Filters();

function useFilters() {
    const [filters, setFilters] = useState<any>(FILTERS);

    useEffect(() => {
      FILTERS.register(setFilters);
        return () => {
          FILTERS.unregister(setFilters);
        }
    }, [])


    return filters;
}

export default useFilters;